/**
 * Fala com o backend do proprio apidocs (`window.API_SELF`, mesma origem) --
 * nao com `window.API_AUTH`, que e so para sessao/appmenu.
 */
import { apiRequest } from '@/services/api/apiClient.js';

/** @returns {Promise<Array<{pacote: string, titulo: string}>>} */
export async function listarPacotes() {
    return apiRequest({
        client: window.API_SELF,
        method: 'get',
        url: 'docs',
    });
}

/** @returns {Promise<object>} spec OpenAPI mesclada (openapi/info/paths) */
export async function carregarSpec(pacote) {
    return apiRequest({
        client: window.API_SELF,
        method: 'get',
        url: `docs/${pacote}`,
    });
}
